import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    this.blankStoredValues()
  }

  blankStoredValues() {
    this.CHECK_ID = '';
    this.CHECK_REFUNDABLE = false;
    this.TICKET_ID = '';
    this.MODAL_UUID = '';
    this.MODAL_BACKGROUND = '';
    this.REFUND_AMOUNT = '';
    this.REFUND_AMOUNT_DISPLAY_VALUE = '';
    this.REFUND_AMOUNT_AVAILABLE = '';
    this.ORIGINAL_PAYMENT_AMOUNT = '';
    this.FORM_OBJECT = ''
    this.MODAL_OBJECT = '';
    this.MODAL_SUBMIT_BTN = ''
    this.MODAL_CANCEL_BTN = ''
  }

  selectCheck(event) {
    const dataset = event.target.dataset
    this.CHECK_ID = dataset.checkId
    this.CHECK_REFUNDABLE = dataset.checkRefundable === 'true'
    this.TICKET_ID = dataset.ticketId
    this.REFUND_AMOUNT = dataset.refundAmount
    this.REFUND_AMOUNT_DISPLAY_VALUE = `${dataset.refundAmount / 100.0}`
    this.REFUND_AMOUNT_AVAILABLE = dataset.amountAvailableForRefund
    this.ORIGINAL_PAYMENT_AMOUNT = dataset.originalPaymentAmount
    this.MODAL_UUID = dataset.modalUuid
    document.MODAL_UUID = dataset.modalUuid
    this.presentModal()
  }

  presentModal() {
    if (this.MODAL_OBJECT === '') {
      this.setModal()
    }
    document.querySelector('#ticket-check-id-title').innerHTML = `Refund Ticket Check ID: ${this.CHECK_ID}`
    document.querySelector('#available-for-refund').innerHTML = this.REFUND_AMOUNT_AVAILABLE
    document.querySelector('#original-payment-amount').innerHTML = this.ORIGINAL_PAYMENT_AMOUNT

    if (this.CHECK_REFUNDABLE) {
      this.MODAL_OBJECT.querySelector('#ticket_check_refund_amount').removeAttribute('disabled');
    }
    this.MODAL_OBJECT.querySelector('#ticket_check_refund_amount').value = this.REFUND_AMOUNT_DISPLAY_VALUE
    this.MODAL_OBJECT.querySelector('#ticket_check_refund_notes').value = ''
    this.MODAL_OBJECT.querySelector('#ticket_check_refund_amount').setAttribute('max', this.REFUND_AMOUNT_DISPLAY_VALUE)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    this.MODAL_BACKGROUND.classList.remove('hidden')
    this.MODAL_OBJECT.classList.remove('hidden')
    this.setFormUrl()
  }

  setModal() {
    this.MODAL_BACKGROUND = document.getElementById('VC-MODAL-BG')
    this.MODAL_OBJECT = document.getElementById(`modal-${this.MODAL_UUID}`)
    this.MODAL_CANCEL_BTN = document.getElementById('REFUND_CHECK_CANCEL_BTN')
    this.MODAL_SUBMIT_BTN = document.getElementById('REFUND_CHECK_SUBMIT_BTN')
    document.closeModal = e => {
      e.preventDefault();
      document.getElementById('VC-MODAL-BG').classList.add('hidden')
      document.getElementById(`modal-${document.MODAL_UUID}`).classList.add('hidden')
      this.MODAL_OBJECT.querySelector('#REFUND_CHECK_SUBMIT_BTN').removeEventListener('click', this.confirmRefund);
    }
    this.MODAL_CANCEL_BTN.addEventListener('click', e => {
      document.closeModal(e)
    })

    this.MODAL_OBJECT.querySelector('#REFUND_CHECK_SUBMIT_BTN').addEventListener('click', this.confirmRefund);
    this.trackInputs();
  }

  // tracks user input to ensure all required fields are filled
  trackInputs() {
    let trackedInput = this.MODAL_OBJECT.getElementsByClassName('track-input');
    Array.from(trackedInput).forEach(input => input.addEventListener('input', this.handleSubmitButton));
  }

  // confirm refund value before submitting
  confirmRefund(e) {
    let amount = this.closest('form').querySelector('#ticket_check_refund_amount').value

    if (!confirm(`Are you sure you want to refund $${amount} ? This cannot be undone.`)) { // eslint-disable-line no-alert
      e.preventDefault();
    }
  }

  // handles the submit button
  // disables the submit button when one or more required fields are empty
  handleSubmitButton() {
    let filled = true;
    let formInputs = Array.from(this.closest('form').getElementsByClassName('track-input'));
    let submitButton = this.closest('form').querySelector('#REFUND_CHECK_SUBMIT_BTN');

    formInputs.forEach(el => {
      if (el.value.trim().length <= 0) {
        filled = false
      }
    });

    if (filled) {
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.setAttribute('disabled', true);
    }
  }

  setFormUrl() {
    const the_url = `/sandbar/admin/tickets/${this.TICKET_ID}/refund_check/${this.CHECK_ID}`
    this.FORM_OBJECT = document.querySelector('form.ticket_check_refund.ticket_check_refund')
    this.FORM_OBJECT.action = the_url
  }
}
